import { cx } from "class-variance-authority";
import React from "react";
import IOSViewportFix from "../ios-window-fix";

type RegistrationWrapperProps = {
  children: React.ReactNode;
  orgColor?: string;
};

export const RegistrationWrapper = ({
  children,
  orgColor,
}: RegistrationWrapperProps) => {
  return (
    <>
      {/* It seems like as long as one refreshes after changing width from desktop to mobile, the height issue is gone. i.e. on actual mobile devices it shouldn't be an issue. */}
      <IOSViewportFix />
      {/* min-h-screen must not be on mobile, otherwise weird stuff happens. <IOSViewportFix /> doesn't always prevent it. */}
      <div className="relative py-4 px-4 sm:min-h-screen bg-friendly-eskimo flex justify-center items-start">
        <div
          className="bg-navy w-full fixed h-[25vh] top-0"
          style={{
            backgroundColor: orgColor,
          }}
        />
        {/* Fill in background on mobile. <IOSViewportFix /> seems to prevent this from overflowing so long as the window width isn't changed suddenly via dev tools (can still resize window). */}
        <div className="bg-friendly-eskimo min-h-screen max-h-content absolute top-0 w-full -z-10" />
        <div
          className={cx("bg-white shadow rounded z-10", "md:max-w-lg w-full")}
        >
          {children}
        </div>
      </div>
    </>
  );
};
